import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/pages/saas/v2/Index';
const Login = resolve => require(['@/pages/Login'], resolve);
const SignUp = resolve => require(['@/pages/SignUp'], resolve);
const ForgetPassword = resolve => require(['@/pages/ForgetPassword'], resolve);
const GoodsList = resolve => require(['@/pages/GoodsList'], resolve);
const GoodsDetail = resolve => require(['@/pages/GoodsDetail'], resolve);
const PointGoodsDetail = resolve => require(['@/pages/promotion/PointGoodsDetail'], resolve);
const ShoppingCart = resolve => require(['@/pages/ShoppingCart'], resolve);
const Cart = resolve => require(['@/pages/Cart'], resolve);
const Pay = resolve => require(['@/pages/payment/Pay'], resolve);
const PayDone = resolve => require(['@/pages/payment/PayDone'], resolve);
const PayMent = resolve => require(['@/pages/payment/PayMent'], resolve);
const ThirdPay = resolve => require(['@/pages/payment/ThirdPay'], resolve);
const Coupon = resolve => require(['@/pages/CouponCenter'], resolve);
const seckill = resolve => require(['@/pages/promotion/seckill'], resolve);
const article = resolve => require(['@/pages/article/index'], resolve);
const PointMall = resolve => require(['@/pages/promotion/PointMall'], resolve);

/*
 * 会员中心
 * 订单列表
 */
const MyOrder = resolve => require([`@/pages/home/orderCenter/MyOrder`], resolve);
const OrderDetail = resolve => require([`@/pages/home/orderCenter/OrderDetail`], resolve);
const MyAddress = resolve => require(['@/pages/home/orderCenter/MyAddress'], resolve);
const AddAddress = resolve => require(['@/pages/home/orderCenter/AddAddress'], resolve);
const Complain = resolve => require(['@/pages/home/orderCenter/Complain'], resolve);
const AfterSale = resolve => require(['@/pages/home/orderCenter/AfterSale'], resolve);
const AfterSaleDetail = resolve => require(['@/pages/home/orderCenter/AfterSaleDetail'], resolve);
const ApplyAfterSale = resolve => require(['@/pages/home/orderCenter/ApplyAfterSale'], resolve);

/*
 * 会员中心
 */
const Profile = resolve => require(['@/pages/home/memberCenter/Profile'], resolve);
const AccountSafe = resolve => require(['@/pages/home/memberCenter/AccountSafe'], resolve);
const ModifyPwd = resolve => require(['@/pages/home/memberCenter/ModifyPwd'], resolve);
const Favorites = resolve => require(['@/pages/home/memberCenter/Favorites'], resolve);
const Distribution = resolve => require(['@/pages/home/memberCenter/Distribution'], resolve);
const CommentList = resolve => require(['@/pages/home/memberCenter/CommentList'], resolve); // 评价列表
const AddEval = resolve => require(['@/pages/home/memberCenter/evaluation/AddEval'], resolve); // 添加评价
const EvalDetail = resolve => require(['@/pages/home/memberCenter/evaluation/EvalDetail'], resolve);
const ComplainList = resolve => require(['@/pages/home/memberCenter/ComplainList'], resolve);
const ComplainDetail = resolve => require(['@/pages/home/memberCenter/ComplainDetail'], resolve);
const Point = resolve => require(['@/pages/home/memberCenter/Point'], resolve);
const MsgList = resolve => require(['@/pages/home/memberCenter/memberMsg/MsgList'], resolve);
const MsgDetail = resolve => require(['@/pages/home/memberCenter/memberMsg/MsgDetail'], resolve);

/*
 * 会员中心
 * 账户中心
 * */
const Coupons = resolve => require(['@/pages/home/userCenter/Coupons'], resolve);
const MyTracks = resolve => require(['@/pages/home/userCenter/MyTracks'], resolve);
const MoneyManagement = resolve => require(['@/pages/home/userCenter/MoneyManagement'], resolve);

const Home = resolve => require(['@/pages/user/Home'], resolve);

const Merchant = resolve => require(['@/pages/Merchant'], resolve);
const UserMain = resolve => require(['@/pages/home/Main'], resolve);

/**
 * 店铺入驻
 */
const ShopEntry = resolve => require(['@/pages/shopEntry/ShopEntry'], resolve);

Vue.use(Router);

const SAAS = [
  {
    path: '/old',
    component: () => import('@/pages/saas/NIndex')
  },
  {
    path: '/house/list',
    name: 'HouseList',
    component: () => import('@/pages/saas/House/list')
  },
  {
    path: '/house/home',
    name: 'HouseHome',
    component: () => import('@/pages/saas/House/home')
  },
  {
    path: '/house/home/detail',
    name: 'HouseDetail',
    component: () => import('@/pages/saas/House/detail')
  },
  {
    path: '/house/yue',
    name: 'HouseYue',
    component: () => import('@/pages/saas/House/yue')
  },
  {
    path: '/web/privacy',
    name: 'PrivacyPolicy',
    component: () => import('@/pages/saas/web/privacy')
  },
  {
    path: '/web/user',
    name: 'UserPolicy',
    component: () => import('@/pages/saas/web/user')
  },
  {
    path: '/web/about',
    name: 'About',
    component: () => import('@/pages/saas/web/about')
  },
  {
    path: '/act/recruit',
    name: 'Recruit',
    component: () => import('@/pages/saas/act/recruit')
  },
  {
    path: '/act/new',
    name: 'NewMember',
    component: () => import('@/pages/saas/act/new')
  },
  {
    path: '/act/play',
    name: 'Play',
    component: () => import('@/pages/saas/act/play')
  },
  {
    path: '/act/strawberry',
    name: 'Strawberry',
    component: () => import('@/pages/saas/act/strawberry')
  },
  {
    path: '/act/citywalk',
    name: 'Citywalk',
    component: () => import('@/pages/saas/act/citywalk')
  },


  // v2
  {
    path: '/v2/login',
    component: () => import('@/pages/saas/v2/Login')
  },
  {
    path: '/v2/pay',
    component: () => import('@/pages/saas/v2/Pay')
  },
  {
    path: '/v2/homestay',
    component: () => import('@/pages/saas/v2/HomeStay')
  },
  {
    path: '/v2/homestay/list',
    component: () => import('@/pages/saas/v2/HomeStay/list')
  },
  {
    path: '/v2/homestay/detail',
    component: () => import('@/pages/saas/v2/HomeStay/detail')
  },
  {
    path: '/v2/homestay/select',
    component: () => import('@/pages/saas/v2/HomeStay/select')
  },
  // 订单中心-我的订单-订单详情
  {
    path: '/cent/order/status',
    component: () => import('@/pages/saas/v2/cent/order/status'),
  },
  {
    path: '/cent',
    redirect: '/cent/order',
    component: () => import('@/pages/saas/v2/cent'),
    children: [
      // 订单中心-我的订单
      {
        path: 'order',
        component: () => import('@/pages/saas/v2/cent/order'),
      },
      // 订单中心-评价晒单
      {
        path: 'appraise',
        component: () => import('@/pages/saas/v2/cent/appraise'),
      },

      // 个人中心-我的个人中心
      {
        path: 'person',
        component: () => import('@/pages/saas/v2/cent/user/person'),
      },
      // 个人中心-消息通知
      {
        path: 'message',
        component: () => import('@/pages/saas/v2/cent/message'),
      },
      // 个人中心-喜欢的商品
      {
        path: 'likes',
        component: () => import('@/pages/saas/v2/cent/likes'),
      },
      // 个人中心-优惠券
      {
        path: 'coupon',
        component: () => import('@/pages/saas/v2/cent/coupon'),
      },
      // 个人中心-收货地址
      {
        path: 'address',
        component: () => import('@/pages/saas/v2/cent/address'),
      },

      // 账户管理-个人信息
      {
        path: 'info',
        component: () => import('@/pages/saas/v2/cent/user/info'),
      },
      // 账户管理-修改密码
      {
        path: 'password',
        component: () => import('@/pages/saas/v2/cent/user/password'),
      },
    ]
  }
]

// 重复跳转当前路由时报错解决
const originalPush = Router.prototype.push
Router.prototype.push = function (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'hash',
  // mode: 'history',
  routes: [...SAAS, {
    path: '/', // 首页
    name: 'Index',
    component: Index
  },
  {
    path: '/login', // 登陆
    name: 'login',
    component: Login,
    meta: {
      title: 'LiLi 登录'
    }
  },
  {
    path: '/SignUp', // 注册
    name: 'SignUp',
    component: SignUp,
    meta: {
      title: 'LiLi 注册'
    }
  },
  {
    path: '/forgetPassword', // 忘记密码
    name: 'forgetPassword',
    component: ForgetPassword,
    meta: {
      title: 'LiLi 忘记密码'
    }
  },
  {
    path: '/goodsList', // 商品列表
    name: 'GoodsList',
    component: GoodsList
  },
  {
    path: '/goodsDetail', // 商品详情
    name: 'GoodsDetail',
    component: GoodsDetail,
    meta: {title: '商品详情'}
  },
  {
    path: '/pointGoodsDetail', // 商品详情
    name: 'PointGoodsDetail',
    component: PointGoodsDetail,
    meta: {title: '积分商品'}
  },
  {
    path: '/shoppingCart', // 头部购物车
    name: 'ShoppingCart',
    component: ShoppingCart
  },
  {
    path: '/cart', // 购物车
    name: 'Cart',
    component: Cart,
    meta: {title: '购物车'}
  },
  {
    path: '/pay', // 支付页面
    name: 'Pay',
    component: Pay,
    meta: {title: '订单结算'}
  },
  {
    path: '/payMent',
    name: 'PayMent',
    component: PayMent
  },
  {
    path: '/PointMall',
    name: 'PointMall',
    component: PointMall,
    meta: {title: '积分商城'}
  },
  {
    path: '/qrpay', // 三方支付
    name: 'qrpay',
    component: ThirdPay
  },
  {
    path: '/payDone', // 支付成功页面
    name: 'PayDone',
    component: PayDone
  },
  {
    path: '/article', // 文章页面
    name: 'article',
    component: article,
    meta: {
      title: '帮助中心'
    }
  },
  {
    path: '/shopEntry',
    name: 'shopEntry',
    component: ShopEntry,
    meta: {
      title: '店铺入驻'
    }
  },
  {
    path: '/coupon',
    name: 'coupon',
    component: Coupon,
    meta: {
      title: '领券中心'
    }
  },
  {
    path: '/seckill',
    name: 'seckill',
    component: seckill,
    meta: {
      title: '限时秒杀'
    }
  },
  {
    path: '/home', // 主页
    component: Home,
    children: [{
      path: '/',
      name: 'Home',
      component: UserMain,
      meta: {
        title: '会员中心'
      }
    },
    {
      path: 'MyTracks',
      name: 'MyTracks',
      component: MyTracks,
      meta: {title: '我的足迹'}
    },
    {
      path: 'MoneyManagement',
      name: 'MoneyManagement',
      component: MoneyManagement
    },
    {
      path: 'Complain',
      name: 'Complain',
      component: Complain
    },
    {
      path: 'Coupons',
      name: 'Coupons',
      component: Coupons
    },
    {
      path: 'CommentList',
      name: 'CommentList',
      component: CommentList,
      mate: {title: '评价列表'}
    },
    {
      path: 'AddEval',
      name: 'AddEval',
      component: AddEval,
      mate: {title: '添加评价'}
    },
    {
      path: 'EvalDetail',
      name: 'EvalDetail',
      component: EvalDetail,
      mate: {title: '评价详情'}
    },
    {
      path: 'ComplainList',
      name: 'ComplainList',
      component: ComplainList
    },
    {
      path: 'ComplainDetail',
      name: 'ComplainDetail',
      component: ComplainDetail
    },
    {
      path: 'AccountSafe',
      name: 'AccountSafe',
      component: AccountSafe
    },
    {
      path: 'ModifyPwd',
      name: 'ModifyPwd',
      component: ModifyPwd
    },
    {
      path: 'Favorites',
      name: 'Favorites',
      component: Favorites,
      meta: {title: '我的收藏'}
    },
    {
      path: 'Distribution',
      name: 'Distribution',
      component: Distribution,
      meta: {title: '分销推荐'}
    },
    {
      path: 'Point',
      name: 'Point',
      component: Point,
      meta: {title: '我的积分'}
    },
    {
      path: 'Profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: 'AfterSale',
      name: 'AfterSale',
      component: AfterSale,
      meta: {title: 'LiLi 售后'}
    },
    {
      path: 'ApplyAfterSale',
      name: 'ApplyAfterSale',
      component: ApplyAfterSale,
      meta: {title: '申请售后'}
    },
    {
      path: '/home/MyAddress',
      name: 'MyAddress',
      component: MyAddress,
      meta: {title: '收货地址'}
    },
    {
      path: 'AddAddress',
      name: 'AddAddress',
      component: AddAddress
    },
    {
      path: 'MsgList',
      name: 'MsgList',
      component: MsgList,
      meta: {title: '我的消息'}
    },
    {
      path: 'MsgDetail',
      name: 'MsgDetail',
      component: MsgDetail,
      meta: {title: '我的消息'}
    },
    {
      path: 'MyOrder',
      name: 'MyOrder',
      component: MyOrder,
      meta: {title: '我的订单'}
    },
    {
      path: 'OrderDetail',
      name: 'OrderDetail',
      component: OrderDetail,
      meta: {title: '订单详情'}
    },
    {
      path: 'AfterSaleDetail',
      name: 'AfterSaleDetail',
      component: AfterSaleDetail,
      meta: {title: '售后详情'}
    }
    ]
  },
  {
    path: '/merchant',
    name: 'Merchant',
    component: Merchant,
    meta: {title: '店铺'}
  }
  ],
  scrollBehavior (to, from, savePosition) {
    if (savePosition) {
      return savePosition
    } else {
      return {x: 0, y: 0}
    }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js